import React, {
  Component
} from 'react';
const $=window.$;

export default class LatestThinking extends Component {

 componentDidMount() {
   setTimeout(()=>{
    //Fancy Box
    $(".fancybox").fancybox({
     autoPlay : true, //  slideshow will start after opening the first gallery item
     playSpeed : 3000 // 3sec pause between changing next item
    });
    $('.fancybox-media')
    .attr('rel', 'media-gallery')
    .fancybox({
     openEffect : 'none',
     closeEffect : 'none',
     prevEffect : 'none',
     nextEffect : 'none',
     arrows : false,
     autoPlay : true,
     playSpeed : 3000,
     helpers : {
     media : {},
     buttons : {}
    }
    });
    // Latest Thinking Carousel
    var owl = $('#thinking-carousel');
    owl.owlCarousel({
     goToFirstSpeed :2000,
     loop:true,
     autoplay:true,
     autoplayTimeout:10000,
     autoplayHoverPause:true,
        responsive: {
      0:{ items:1 },
      640:{ items:1 },
      768:{ items:1 },
      1024:{ items:2}
     },
      nav : true,
      dots : false,
      margin: 15
    });

   },100);
 }

  render() {
    return (
     <section className="latest-thinking">
       <div className="row">
         <h2>Our Thought Leadership</h2>
         <span className="line2"></span>
         <p>We interpret trends in education technology</p>
         <div id="thinking-carousel" className="owl-carousel owl-loaded">
           <div className="item">
             <div className="team-detail our-think video"> <a className="fancybox-media" href="https://youtu.be/HBUhKLw1GTI"> <img src={process.env.PUBLIC_URL +'/images/OUUK_361DM_Agreement.jpg'} alt="" className="video-img"/> <span className="vid-name">Steve Hill, Director of External Engagement, Open University, UK and P. Ram Mohan, Chairman and Managing Director, 361 Degree Minds exchange copies of their content licence agreement</span> </a> </div>
           </div>
           <div className="item">
             <div className="team-detail our-think video"> <a className="fancybox-media" href="https://youtu.be/HBUhKLw1GTI"> <img src={process.env.PUBLIC_URL +'/images/OUUK_361DM_interaction.jpg'} alt="" className="video-img"/> <span className="vid-name">Steve Hill, Director of External Engagement, Open University, UK, makes a point at a media interaction in Chennai on Thursday. Others in the picture (Left to Right) are Viren Patel, Director, 	 University, UK, P. Ram Mohan, CMD, Threesixtyone Degree Minds and C.P. Gopinathan, Co-founder, Threesixtyone Degree Minds</span> </a> </div>
           </div>
           <div className="item">
             <div className="team-detail our-think">
               <h2>Online design course for engineering students</h2>
               <p style={{textAlign:'justify'}}>Threesixtyone Degree Minds, an online learning platform, is introducing online courses on design. In a press note, the platform stated that the Central government’s proposal to make cities smart required integration of technology. For smart cities to be accessible and friendly, it is imperative that new visitors can make their way without them requiring help. The courses aim to address this lacunae, the release noted. </p>
               <p style={{textAlign:'justify'}}>The organisation has tied up with the Open University of the United Kingdom to offer two certificate courses — Design for Engineers and Business Management.</p>
               <a href="http://www.thehindu.com/news/cities/chennai/online-design-course-for-engineering-students/article17396981.ece" target="_blank" rel="noopener noreferrer" className="think-read">Read more</a> </div>
           </div>
           <div className="item">
             <div className="team-detail our-think">
               <h2>Is online the way forward?</h2>
               <p style={{textAlign:'justify'}}>Online learning and its pedagogy have to beengineered in a specific manner to meet theaspirations of a range of learners.</p>
               <p style={{textAlign:'justify'}}>States of Tamil Nadu and Andhra Pradesh see a strange conundrum. While almost all students who complete class XII and all those who can afford to pay, end up getting into some higher education programme, tens of thousands of seats go vacant every year in professional and arts/science colleges in these States. Very few youngsters, who can afford it, choose not to enter college.</p>
               <a href="http://www.thehindu.com/todays-paper/tp-features/tp-educationplus/is-online-the-way-forward/article7120364.ece" target="_blank" rel="noopener noreferrer" className="think-read">Read more</a> </div>
           </div>
           <div className="item">
             <div className="team-detail our-think">
               <h2>The engineering job slowdown has begun, what went wrong and how to fix it</h2>
               <p style={{textAlign:'justify'}}>With placements dropping by 40-50% this year compared to the last, the signs are clear that the days of bountiful recruitment are waning.</p>
               <p style={{textAlign:'justify'}}>The academic year 2016-17 is sure to go down as an inflexion point for higher education, particularly for engineering institutions in India.</p>
               <a href="http://www.thenewsminute.com/article/engineering-job-slowdown-has-begun-what-went-wrong-and-how-fix-it-54105" target="_blank" rel="noopener noreferrer" className="think-read">Read more</a> </div>
           </div>
           <div className="item">
             <div className="team-detail our-think">
               <h2>5 Trends That Will Completely Disrupt Indian Higher Education By 2025</h2>
               <p style={{textAlign:'justify'}}>A first year biology student in college uses a 3D virtual reality equipment to enter the human digestive system. There, he watches food getting digested in the body. Simultaneously, his classmate simulates different circumstances to watch from up close how a drug from a capsule gets metabolised and heals an injury inside a vein.</p>
               <p style={{textAlign:'justify'}}>Others in class are using simulation and gaming to see how atoms morph into alloys, or how electrons in a liquid get agitated when subjected to thermal radiation.</p>
               <a href="http://www.huffingtonpost.in/k-ramachandran/5-trends-that-will-completely-disrupt-indian-higher-education-by/?utm_hp_ref=in-homepage" target="_blank" rel="noopener noreferrer" className="think-read">Read more</a> </div>
           </div>
           <div className="item">
             <div className="team-detail our-think">
               <h2>Degree of empowerment</h2>
               <p>Learn while you earn is the way forward in India, with many employees looking to add value to their jobs and themselves with online degrees, say experts </p>
               <p>Harvard University’s Kennedy School of Government released an interesting report in October 2016, which had a significant finding.</p>
               <p>According to a research study, online education is increasing access to high quality higher education, at least among those pursuing postgraduate degree.</p>
               <a href="http://www.dtnext.in/News/TamilNadu/2017/01/05120259/1024863/Degree-of-Empowerment.vpf?Tld=112131" target="_blank" rel="noopener noreferrer" className="think-read">Read more</a> </div>
           </div>
         </div>
       </div>
     </section>
    );
  }

}



// WEBPACK FOOTER //
// ./src/partials/LatestThinking.js